import React from 'react';
import { Typography, CardMedia, Stack, TextField, Button, Box, useMediaQuery, useTheme } from '@mui/material';

// Import your images
import Founder1 from '../../../assets/Landing/contactus.png'; 
import Founder2 from '../../../assets/Landing/fu1.png'; 

export default function FoundersCard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: '100%',
        height: isMobile ? 'auto' : '120vh',
        backgroundColor: '#1C486A',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 4,
      }}
    >
      {/* Heading inside the card */}
      <Typography
        variant={isMobile ? 'h4' : 'h2'}
        textAlign="center"
        sx={{
          fontWeight: 'bold',
          color: '#f1f1f1',
          marginBottom: 4,
        }}
      >
        Book A {' '} 
        <span
          style={{
            color: 'transparent',
            WebkitTextStrokeWidth: '1px',
            WebkitTextStrokeColor: '#f1f1f1',
          }}
        >
          Consultation <br/>
        </span>
         With Us!
      </Typography>

      {/* Main structure (image + form) */}
      <Stack
        direction={isMobile ? 'column' : 'row'}
        spacing={isMobile ? 2 : 4}
        sx={{ width: '100%', justifyContent: 'space-between', alignItems: 'center' }}
      >
        {/* Left: Contact Us Image */}
        <CardMedia
          component="img"
          src={Founder1}
          alt="Contact Us"
          sx={{
            width: isMobile ? '100%' : '40%',
            height: '80vh',
            borderRadius: '20px',
          }}
        />

        {/* Right: Contact Form */}
        <Box
          sx={{
            width: isMobile ? '100%' : '40%',
            height: isMobile ? 'auto' : '80vh',
            background: '#fff',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderRadius: '20px',
            padding: 3,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          {/* Form inside the box */}
          <Box
            component="form"
            sx={{
              width: '100%',
              padding: 2,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            {/* Input fields */}
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              required
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Email"
              variant="outlined"
              fullWidth
              required
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Phone"
              variant="outlined"
              fullWidth
              sx={{ marginBottom: 2 }}
            />
            <TextField
              label="Message"
              variant="outlined"
              fullWidth
              multiline
              rows={4}
              sx={{ marginBottom: 2 }}
            />

            {/* Submit button */}
            <Button
              variant="outlined"
              fullWidth
              sx={{
                borderColor: '#1C486A',
                color: '#1C486A',
                marginTop: 2,
                '&:hover': {
                  backgroundColor: '#1C486A',
                  color: '#fff',
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
}
